module.exports = __webpack_public_path__ + "static/media/MarkerApiMerah.fdddb227.svg";